import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";

// Main single gallery
const lightbox = new PhotoSwipeLightbox({
    gallery: "#pswp-gallery--single",
    children: "a",
    pswpModule: PhotoSwipe,
    showHideAnimationType: "fade",
    arrowPrev: false,
    arrowNext: false,
    counter: false,
    zoom: true
});

lightbox.on("close", () => {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
});

lightbox.init();

// Delegate click events for .js-project-item
document.body.addEventListener("click", (event) => {
    const item = event.target.closest(".js-project-item");
    if (!item) return;

    event.preventDefault();
    const itemId = item.getAttribute("id");

    // Destroy previous instance if exists
    if (window._pswpGalleryInstance) {
        window._pswpGalleryInstance.destroy();
    }

    // Create new instance for the clicked gallery
    const gallery = new PhotoSwipeLightbox({
        gallery: `#${itemId}`,
        children: "a",
        pswpModule: PhotoSwipe,
        showHideAnimationType: "fade",
        arrowPrev: true,
        arrowNext: true,
        counter: true,
        zoom: true
    });

    gallery.on("close", () => {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
    });

    gallery.init();
    gallery.loadAndOpen(0);

    // Store reference to destroy later
    window._pswpGalleryInstance = gallery;
});
